import { useCallback } from 'react';
import { useNotify } from 'react-admin';

import { getIcError } from '../providers/utils';

/**
 * Custom hook to notify Error from Network / server
 */
const useNotifyServerError = () => {
  const notify = useNotify();

  return useCallback(
    (error, fallback) => {
      if (fallback && typeof error !== 'string' && error && !error.message) {
        notify(fallback, { type: 'error' });
      } else {
        notify('ra.notification.server', {
          type: 'error',
          messageArgs: { message: getIcError(error) }
        });
      }
    },
    [notify]
  );
};

export default useNotifyServerError;
